import Vue from 'vue'
import ElementUI, { Header } from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

import axios from 'axios' 
import { Message } from 'element-ui'
import * as echarts from 'echarts'
import "../src/assets/js/axios.config"
import XLSX from 'xlsx'
import App from './App.vue'
import router from './router'
import store from './store'
echarts.registerTheme('dark', darkObj)
// 全局css文件
import './assets/css/reset.css'
import './assets/css/Adaptive.css'
// 引入图标库
import './assets/icon/iconfont.css'
import './plugins/element.js'

// element-ui修改主题色
// import './theme/element/index.css'
// echarts 主题
import  darkObj from './assets/js/dark.json'

// import './css/index.less'
Vue.config.productionTip = false
Vue.prototype.$message = Message;

Vue.prototype.XLSX = XLSX
Vue.prototype.$echarts = echarts 

import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)
//打印
import print from "./utils/print.js"
Vue.use(print);

axios.defaults.baseURL='/chuan-cheng'

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
